import VueWait from 'vue-wait';
export default (function (_ref) {
  var Vue = _ref.Vue,
    app = _ref.app;
  Vue.use(VueWait);
  app.wait = new VueWait({
    useVuex: true
  });
});